import React from 'react';
import trans from '../../translations.json';
import './searchResultDropdown.scss';

const highlightSearchResult = (string, matches) => {
  const substrings = [];
  let previousEnd = 0;
  for (let [start, end] of matches) {
    const prefix = string.substring(previousEnd, start);
    const match = <mark>{string.substring(start, ++end)}</mark>;
    substrings.push(prefix, match);
    previousEnd = end;
  }
  substrings.push(string.substring(previousEnd));
  return <span>{React.Children.toArray(substrings)}</span>;
};

class searchResultDropdown extends React.Component {
  state = {
    btnIndex: 0,
  };

  btnRefs = [];

  componentDidMount() {
    window.addEventListener('keydown', this.handleKeyDown);
  }

  handleKeyDown = (event) => {
    let numOfRes = this.props.numOfRes || 2;
    if (event.key === 'ArrowDown' || event.key === 'Down') {
      if (this.btnRefs[0]) {
        this.setState((prevState) => {
          let newBtnIndex = prevState.btnIndex + 1;
          if (newBtnIndex > numOfRes) {
            newBtnIndex = 0;
          }
          return {
            btnIndex: newBtnIndex,
          };
        });
      }
    }
    if (event.key === 'ArrowUp' || event.key === 'Up') {
      if (this.btnRefs[0]) {
        this.setState((prevState) => {
          let newBtnIndex = prevState.btnIndex - 1;
          if (newBtnIndex < 0) {
            newBtnIndex = numOfRes;
          }
          return {
            btnIndex: newBtnIndex,
          };
        });
      }
    }
    if (event.key === 'Enter') {
      if (this.btnRefs[0]) {
        this.btnRefs[this.state.btnIndex].focus();
      }
    }
    if (event.key === 'Escape' || event.key === 'Esc') {
      if (this.btnRefs[0]) {
        this.props.hideDropdown();
      }
    }
  };

  render() {
    return (
      this.props.results.length !== 0 && (
        <ul
          className="viz-search-result-dropdown"
          style={{
            position: 'absolute',
          }}
          role="toolbar"
        >
          {this.props.results.map((item, idx) => {
            return (
              <li key={idx}>
                <button
                  aria-setsize="4"
                  aria-posinset={idx}
                  className={
                    this.state.btnIndex === idx ? 'btn-focused' : ''
                  }
                  onClick={() =>
                    this.props.handleOnClick(
                      this.props.isHospitalization
                        ? item.item.lhin_name
                        : idx === 0 && this.props.cityFirst
                        ? item.item.city_name
                        : item.item.phu_name,
                    )
                  }
                  ref={(ref) => {
                    this.btnRefs[idx] = ref;
                  }}
                  key={idx}
                  style={{ cursor: 'pointer' }}
                >
                  {this.props.isHospitalization
                    ? item.item.city_name !== 'Toronto' &&
                      highlightSearchResult(
                        item.item.city_name,
                        item.matches[0].indices,
                      )
                    : (idx > 0 || !this.props.cityFirst) &&
                      highlightSearchResult(
                        item.item.phu_name,
                        item.matches[1]
                          ? item.matches[1].indices
                          : item.matches[0].indices,
                      )}{' '}
                  {this.props.isHospitalization
                    ? item.item.city_name !== 'Toronto' && (this.props.lang === 'en' ? ' in ' : 'dans' ) 
                    : (idx > 0 || !this.props.cityFirst) && ' of '}
                  <b>
                    {this.props.isHospitalization
                      ? this.props.lang === 'en' 
                        ? trans.LHIN[item.item.lhin_name.toUpperCase()][this.props.lang] + trans.heatmap.resultRegion[item.item.lhin_name][this.props.lang]
                        : trans.heatmap.resultRegion[item.item.lhin_name][this.props.lang] + trans.LHIN[item.item.lhin_name.toUpperCase()][this.props.lang]
                      : item.matches[1] ||
                        item.matches[0].key === 'city_name'
                      ? highlightSearchResult(
                          item.item.city_name,
                          item.matches[0].indices,
                        )
                      : item.item.city_name}
                  </b>
                </button>
              </li>
            );
          })}
        </ul>
      )
    );
  }
}

export default searchResultDropdown;
